import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cmsContentTextImageDefaultVariants = {}
const cmsContentTextImageCompoundVariants = []

const cmsContentTextImageSlotNames = [
  [
    "container",
    "cms-text-image__container"
  ],
  [
    "imgBox",
    "cms-text-image__imgBox"
  ],
  [
    "title",
    "cms-text-image__title"
  ],
  [
    "text",
    "cms-text-image__text"
  ],
  [
    "preserveImg",
    "cms-text-image__preserveImg"
  ]
]
const cmsContentTextImageSlotFns = /* @__PURE__ */ cmsContentTextImageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cmsContentTextImageDefaultVariants, getSlotCompoundVariant(cmsContentTextImageCompoundVariants, slotName))])

const cmsContentTextImageFn = memo((props = {}) => {
  return Object.fromEntries(cmsContentTextImageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cmsContentTextImageVariantKeys = []
const getVariantProps = (variants) => ({ ...cmsContentTextImageDefaultVariants, ...compact(variants) })

export const cmsContentTextImage = /* @__PURE__ */ Object.assign(cmsContentTextImageFn, {
  __recipe__: false,
  __name__: 'cmsContentTextImage',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cmsContentTextImageVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, cmsContentTextImageVariantKeys)
  },
  getVariantProps
})